import moment from "moment";

const base = {
  filtersInitState() {
    const timePeriodStart = moment(new Date())
      .subtract(4, "days")
      .format("YYYY-MM-DD");
    const timePeriodEnd = moment(new Date())
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    let filters = {
      "Time Period": {
        label: timePeriodStart + " to " + timePeriodEnd,
        name: "Time Period",
        startDate: timePeriodStart,
        endDate: timePeriodEnd,
        type: "date_range"
      }
    };

    const searchParams = new URLSearchParams(window.location.search);
    for (let pair of searchParams.entries()) {
      // console.log(searchParams,pair);
      if (filters[pair[0]] && filters[pair[0]].type === "date_range") {
        if (pair[1].split("to").length > 1) {
          const values = pair[1].split("to");
          const isStartValid = moment(values[0]).isValid();
          const isEndValid = moment(values[1]).isValid();
          if (isStartValid) filters[pair[0]].startDate = values[0];
          if (isEndValid) filters[pair[0]].endDate = values[1];
          if (isStartValid && isEndValid)
            filters[pair[0]].label = `${values[0]} to ${values[1]}`;
          else if (!isStartValid && isEndValid)
            filters[pair[0]].label = `${timePeriodStart} to ${values[1]}`;
          else if (isStartValid && !isEndValid)
            filters[pair[0]].label = `${values[0]} to ${timePeriodEnd}`;
        }
      }
    }
    return filters;
  },
  widgetsInitState() {
    const widgets = {
      Date: {
        name: "Date",
        type: "stats_date",
        data: null,
        csv_data: null,
        columns: null,
        csv_columns: null
      },
      Device: {
        name: "Device",
        type: "device",
        data: null,
        csv_data: null,
        columns: null,
        csv_columns: null
      },
      Source: {
        name: "Source",
        type: "source",
        data: null,
        csv_data: null,
        columns: null,
        csv_columns: null
      }
    };
    return widgets;
  }
};

export default base;
